module.exports = __webpack_public_path__ + "img/10022.21689f43.jpg";